export const hondaFonts = {
  '.atm-caption-6': {
    fontFamily: 'AvenirNext-Bold, AvenirNextBold',
    fontSize: '1rem',
    lineHeight: 'normal',
  },
  '.atm-caption-7': {
    fontFamily: 'AvenirNext-Bold, AvenirNextBold',
    fontSize: '0.875rem',
    lineHeight: 'normal',
  },
  '.atm-secondary-title-5': {
    fontFamily: 'AvenirNext-Bold, AvenirNextBold',
    fontSize: '1.125rem',
    lineHeight: 'normal',
  },
  '.atm-label-1': {
    fontFamily: 'AvenirNext-Medium, AvenirNextMedium',
    fontSize: '0.875rem',
    lineHeight: 'normal',
    letterSpacing: '0.03125rem',
  },
  '.atm-label-2': {
    fontFamily: 'AvenirNext-Medium, AvenirNextMedium',
    fontSize: '0.8125rem',
    lineHeight: 'normal',
  },
  '.atm-label-3': {
    fontFamily: 'AvenirNext-DemiBold, AvenirNextSemiBold',
    fontSize: '0.75rem',
    lineHeight: 'normal',
  },
  '.atm-caption-5': {
    fontFamily: 'AvenirNext-DemiBold, AvenirNextSemiBold',
    fontSize: '1rem',
    lineHeight: 'normal',
  },
  '.atm-caption-10': {
    fontFamily: 'AvenirNext-Bold, AvenirNextBold',
    fontSize: '0.75rem',
    lineHeight: 'normal',
    letterSpacing: '0.01875rem',
  },
  '.atm-paragraph-5': {
    fontFamily: 'AvenirNext-Regular, AvenirNext',
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
  '.atm-paragraph-8': {
    fontFamily: 'AvenirNext-Regular, AvenirNext',
    fontSize: '0.75rem',
    lineHeight: 'normal',
  },
  '.atm-paragraph-9': {
    fontFamily: 'AvenirNext-DemiBold, AvenirNextSemiBold',
    fontSize: '0.875rem',
    lineHeight: 'normal',
    letterSpacing: '0.01875rem',
  },
  '.atm-title-4': {
    fontFamily: 'AvenirNext-Regular, AvenirNext',
    fontSize: '2.25rem',
    lineHeight: '2.5rem',
    letterSpacing: '-0.045rem',
  },
  '.atm-title-5': {
    fontFamily: 'AvenirNext-Thin, AvenirNextThin',
    fontSize: '1.875rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.00625rem',
    fontWeight: '275',
  },
};
